import ProductsData from '../../../../services/product/products-data'
import { TagGroup } from '../models'
import {
  groupBy as cbxGroupBy,
  productMapper as cbxProductMapper,
  sortItemsBySequenceNumber,
  sortVariantsBySequenceNumber
} from '.'

export const fetchProductsData = async (
  config: {
    cbxUrl: string
    market: string
    locale: string
    channel: string
  },
  superTags: string,
  groupBy: {
    productGroups: {
      productFamily: string
      productProperty: string
    }[]
    except: string[]
  }
) => {
  const data = await ProductsData.getProductsData({
    ...config,
    superTags
  })
  const gcodes = data?.items?.map(({ globalArticleCode }) => globalArticleCode)
  // middleware
  const facets = data?.facets?.reduce(
    (acc: TagGroup[], { tagGroups = [] }) => [...acc, ...tagGroups],
    []
  )
  const items = Object.values(
    cbxGroupBy(data?.items, cbxProductMapper, groupBy)
  )
    .map((item) => ({
      ...item,
      variants: item.variants.slice().sort(sortVariantsBySequenceNumber)
    }))
    .slice()
    .sort(sortItemsBySequenceNumber)

  return {
    data: {
      gcodes,
      facets,
      items
    }
  }
}
